import React from 'react';
import { Brodcrumb } from '../../components/ui/UtilsLayout';
import { iconsPath, imagePath, videoPath } from '../../utils/imagePath';
import { BackgroundWithCurve, BulletSection, CaseStudiesImageCard, CaseStudyHeading, Section } from '../../utils/CaseStudiesComponents';

// CaseStudy Component
const SpaceImmersiveExperience = () => {
  return (
    <div className="flex justify-center px-5 md:px-10 lg:px-16  items-center gap-6 text-white pb-16 relative">
      <BackgroundWithCurve />
      <div className="max-w-[1200px] w-full  pt-24 md:pt-32 relative z-10">
        {/* Breadcrumb Navigation */}
        <Brodcrumb
          data={{
            name: 'Space',
            item: [
              { name: 'Industry Use Cases', path: '/all-industries' },
              {
                name: 'Defence & Aerospace',
                path: '/industries/defence-aerospace',
              },
            ],
          }}
        />

        <div className="my-10 flex flex-col w-full gap-10">
          {/* Header Section with Logo */}
          <div className="flex gap-3 md:gap-5 lg:gap-10">
            <div className="flex justify-center items-center  bg-gradient-to-t from-[#474747] to-[#292929] shadow-[0px_0px_4px_1px_rgba(0,0,0,0.25)] h-20 w-20 md:h-20 md:w-20 lg:h-24 lg:w-24 rounded-lg">
              {/* Company Logo */}
              {imagePath?.SpaceLogo ? (
                <img
                  className="h-14 w-14 md:h-12 md:w-12 lg:h-16 lg:w-16 object-contain"
                  src={imagePath?.SpaceLogo}
                  alt="Space Logo"
                />
              ) : (
                <span className="text-gray-400 text-xs">No Logo</span>
              )}
            </div>

            {/* Case Study Heading */}
            <div className="flex flex-col gap-2 md:gap-5 justify-center">
              <CaseStudyHeading title="Space" desc="4D Immersive Experience" />
            </div>
          </div>

          <div className="relative">
            {/* Video Container - Responsive aspect ratio */}
            <div className="relative w-full aspect-video bg-[#31333A] shadow-[0px_0px_21px_4px_rgba(0,0,0,0.25)] flex justify-center items-center ">
              {/* Play Icon */}
              {videoPath?.Space4D && (
                <video
                  src={videoPath.Space4D}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-full h-full object-cover rounded-lg"
                >
                  Your browser does not support the video tag.
                </video>
              )}
              {/* {iconsPath?.QRIcon && (
                <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 lg:-top-8 lg:-right-8 bg-[#fff] p-2 md:p-3 rounded-[10px]">
                  <img
                    src={iconsPath.QRIcon}
                    alt="QR Code"
                    className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24"
                  />
                </div>
              )} */}
            </div>
          </div>

          {/* Case Study Description */}
          <Section
            title="4D immersive experience for a leading space organization"
            subtitle="4D experience of space concepts and organization assets"
            content="Customer is a large and leading organization known for successful delivery of space programs.
            The objective of this project was to promote learning and development of the challenges and
            excitement associated with space programs among the next generation students and
            professionals."
          />

          <Section
            title="Execution"
            content={[
              'Spatial Grid was engaged to design and develop an application that can inspire and encourage students to learn and understand the space program. The Spatial Grid team designed an application to demonstrate the complexities and get an immersive experience of space travel. Application designed by the team is a 4-dimensional (4D) experience of travel in space which leveraged a pneumatic chair with haptic controls and a VR headset.',
            ]}
          />
          <BulletSection
            introText="This projected involved development of the following components:"
            bulletPoints={[
              'VR based experience of traveling in space',
              'Pneumatic chair with haptic feedback controls',
              'Interfacing with control systems to synchronize the scene and pneumatic chair',
              'Creation of Space scene animation and simulation',
            ]}
            closingText="Leveraging the Spatial Grid platform the experience was completed in 10 weeks. Discussions
            regarding the support and maintenance including development of additional experiences is in
            progress."
          />

          {/* Image Grid Section */}
          <div className="flex flex-col gap-3">
            <div className="flex md:flex-row flex-col gap-10 md:gap-20 w-full">
              <CaseStudiesImageCard
                image={imagePath?.Space4D1}
                title="Simulation"
              />
              <CaseStudiesImageCard
                image={imagePath?.Space4D2}
                title="Multi-Sensory Space Exploration"
              />
            </div>
          </div>

          {/* Impact Section */}
          <div className="flex flex-col gap-3">
            <Section
              title="Impact"
              content="Organization was able to increase the overall footfall by 5 times. Additionally, reviews
              regarding the overall experience have increased by 12-fold."
            />
          </div>
        </div>
      </div>
    </div>
  );
};
<CaseStudyHeading />;
<CaseStudiesImageCard />;

export default SpaceImmersiveExperience;
